/**
 * Renames and removes some fields from Google geolocation objects. (lng => lon,
 * postalCode => zip)
 *
 * @param {object} location A location object from a Google util
 */
export const normalizeLocation = location => {
  // if we don't have both lat and lon then we should
  // fail so that this location cannot be saved. It's
  // not a valid location that would be useful to anything.
  // longitude can be either lng or lon, so check both
  const hasLon = !!location && (!!location.lng || !!location.lon)
  if (!location || !location.lat || !hasLon) return

  location.lat = Number(location.lat)
  location.lon = Number(location.lng) || Number(location.lon)
  location.zip = location.postalCode || location.zip
  delete location.lng
  delete location.postalCode
  delete location.id
  return location
}
